let timer = null
let canRun = true;
export function Debounce(fn,interval = 200) { // 防抖方法
    return function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, arguments)
        }, interval);
    };
}
export function Throttle (fn,interval = 200) { // 节流方法
	return function() {
		if (!canRun) return
		canRun = false
		setTimeout(function() {
			fn.apply(this, arguments)
			canRun = true
		}, interval);
	}
}